import { mapState } from '@/store/helpers';
import { getSearchTagMixin } from '../_center-adaptor/tag'

export default (isSearchCenter) => {
    return {
        i18next: {
            ns: 'md-search-result'
        },
        mixins: [getSearchTagMixin(isSearchCenter)],
        data: function() {
            return {
                
            };
        },
        computed: {
            ...mapState({
                "searchConfigMap": store => store.searchConfigMap,
                "allConditions": "allConditions",
                "conditionSort": "conditionSort",
                "conditions": "conditions"
            }),
        },
        props: {
            theme: {
                type: String,
                default: '',
            },
            isMobileSize: {
                type: Boolean,
                default: false
            },
            isDisabledEmptyZoomOut: {
                type: Boolean,
                default: false
            },
            showMap: {
                type: Boolean,
                default: false
            },
            emptyImg: {
                type: String,
                default: '//cdn.chime.me/image/fs/sitebuild/2023913/1/original_53a5129e-900b-469d-bf57-6d6dbcbb859e.png'
            },
            isFeatureAreaPage: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            handlerZoomOut() {
                this.$emit('handlerZoomOut')
            }
        }
    };
}
